<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="companiesService"
    [idKey]="'companyId'"
></base-index-page>